/* TASK-217 (issue #335): the ONE allowlist for "where may the app hand the
   browser off to after auth". Lifted out of Auth.jsx so the pending-authorize
   resume hook (components/PendingOAuthResume.jsx) applies the SAME rule to a
   server-supplied resumeUrl — and so the rule is testable without a DOM. */
import { defaultBaseURL } from '../services/api/client.js';

// The allowlisted origin is THIS environment's API — the same origin the app
// already sends every authenticated request to — not a hardcoded production
// host. Hardcoding it meant the MCP OAuth hand-back was silently rejected
// anywhere but production, so the flow could never be tested on staging or dev.
// Deriving does not widen the allowlist: it is still exactly one origin, and
// only its /oauth-mcp/ consent paths. Returns the normalized absolute URL to
// navigate to, or null for anything else (relative paths, other origins,
// scheme downgrades, non-strings).
export function safeNext(raw, baseURL = defaultBaseURL()) {
  if (!raw || typeof raw !== 'string') return null;
  try {
    const url = new URL(raw);
    const apiOrigin = new URL(baseURL).origin;
    if (url.origin === apiOrigin && url.pathname.startsWith('/oauth-mcp/')) return url.toString();
  } catch {}
  return null;
}
